import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { Category } from "./category"
import { Album } from "./album";

export class Curated extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Curated' })
    MODELNAME: string;

    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'Date?' })
    updated_at?: string;

    @JsonProperty({ type: 'Date?' })
    created_at?: string;

    @JsonProperty({ type: 'number' })
    position: number;

    @JsonProperty({ type: 'boolean?' })
    is_followed?: boolean;

    @JsonProperty({ type: 'string' })
    title: string;

    @JsonProperty({ type: 'string?' })
    description?: string;

    @JsonProperty({ type: 'string' })
    slug: string;

    @JsonProperty({ type: 'string?' })
    subtitle?: string;

    @JsonProperty({ type: 'string?' })
    curator?: string;

    @JsonProperty({ type: 'string' })
    image: string;

    @JsonProperty({ type: 'string' })
    image_thumbnail: string;

    @JsonProperty({ clazz: Category, type: 'Category' })
    category: Category

    @JsonProperty({ clazz: Album, type: 'Album?' })
    albums?: Album[]
}



// WEBPACK FOOTER //
// ./src/api/src/models/curated.ts